require('./contractSectionView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { formatText } = require('core/i18n').i18n;
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKTable } = require('commonsComponents/OKTable');
// @ components
const ContractSectionRow = require('components/myProfile/myProfileDocumentationContracts/contractSectionView/contractSectionRow/contractSectionRow');
// @ constants
const { API_CENTER, API_ENTERPRISE_NUMBER } = require('constants/index');

class ContractSection extends React.Component {

    buildRowsAccounts() {
        let data = this.filterData(this.props.immData, ['interventionType']);
        let response = data.valueSeq().map((immData, index) => {
            // Check if this commented code is not the correct value for contract number
            /*const codbban = `${API_ENTERPRISE_NUMBER}${API_CENTER}${immData.get(
                'newProduct'
            )}${immData.get('newContractNumber')}`;
            const contractLink = `/myprofile/documentation/contracts/account/${immData.getIn([
                'ibanComplex',
                'codbban'
            ])}`;*/
            const codbban = `${immData.getIn(['ibanComplex', 'codbban'])}`;
            const contractLink = `/myprofile/documentation/contracts/account/${codbban}`;
            const intervention = formatText(`interventionTypes-${immData.get('interventionType')}`);
            const openingDate = immData.get('openingDate');

            return (
                <ContractSectionRow
                    key={index}
                    contractLink={contractLink}
                    intervention={intervention}
                    codbban={codbban}
                    openingDate={openingDate}
                />
            );
        });

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    buildRowsCards() {
        let data = this.filterData(this.props.immData, ['interventionType']);
        let response = data.valueSeq().map((immData, index) => {
            const wholeContract = `${API_ENTERPRISE_NUMBER}${API_CENTER}${immData.getIn(['contract', 'product'])}${immData.getIn(['contract', 'number'])}`;
            const codbban = immData.get('number').replace(/\s+/g, '');
            const contractLink = `/myprofile/documentation/contracts/cards/${codbban}`;
            const intervention = formatText(`interventionTypes-${immData.get('interventionType')}`);
            const openingDate = null;

            return (
                <ContractSectionRow
                    key={index}
                    contractLink={contractLink}
                    intervention={intervention}
                    codbban={wholeContract}
                    openingDate={openingDate}
                />
            );
        });

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    buildRowsDeposits() {
        let data = this.filterData(this.props.immData, ['interventionType']);
        let response = data.valueSeq().map(
            ((immData, index) => {
                const codbban = immData.get('fullContractNumber');
                const contractLink = `/myprofile/documentation/contracts/deposits/${immData.get(
                    'id'
                )}`;
                const intervention = formatText(`interventionTypes-${immData.get('interventionType')}`);
                const openingDate = null;

                return (
                    <ContractSectionRow
                        key={index}
                        contractLink={contractLink}
                        intervention={intervention}
                        codbban={codbban}
                        openingDate={openingDate}
                    />
                );
            }).bind(this)
        );

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    buildRowsLoans() {
        let data = this.filterData(this.props.immData, ['interventionType']);
        let response = data.valueSeq().map((immData, index) => {
            const codbban = `${API_ENTERPRISE_NUMBER}${API_CENTER}${immData.get('newProduct')}${immData.get('newContractNumber')}`;
            const contractLink = `/myprofile/documentation/contracts/loans/${immData.get('loanId')}`;
            const intervention = formatText(`interventionTypes-${immData.get('interventionType')}`);
            const openingDate = immData.get('openingDate');

            return (
                <ContractSectionRow
                    key={index}
                    contractLink={contractLink}
                    intervention={intervention}
                    codbban={codbban}
                    openingDate={openingDate}
                />
            );
        });

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    buildRowsMortgages() {
        let data = this.filterData(this.props.immData, ['interventionType']);
        let response = data.valueSeq().map((immData, index) => {
            const codbban = `${immData.get('fullContractNumber')}`;
            const contractLink = `/myprofile/documentation/contracts/mortgages/${immData.get(
                'loanId'
            )}`;
            const intervention = formatText(`interventionTypes-${immData.get('interventionType')}`);
            const openingDate = immData.get('openingDate');

            return (
                <ContractSectionRow
                    key={index}
                    contractLink={contractLink}
                    intervention={intervention}
                    codbban={codbban}
                    openingDate={openingDate}
                />
            );
        });

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    buildRowsPreGrantedCredits() {
        let data = this.filterData(this.props.immData, ['interventionType']);
        let response = data.valueSeq().map((immData, index) => {
            const codbban = `${API_ENTERPRISE_NUMBER}${API_CENTER}${immData.get(
                'newProduct'
            )}${immData.get('newContractNumber')}`;
            const contractLink = `/myprofile/documentation/contracts/pregrantedcredit/${immData.get(
                'iban'
            )}`;
            const intervention = formatText(`interventionTypes-${immData.get('interventionType')}`);
            // Pregranted credits, for now, dont have an openingdate, thus hardcoding this...
            // To go with the flow. This should be improved in case there is more than one...
            // Pregrantedcredit precontractual information through time.
            const openingDate = '2017-01-01';

            return (
                <ContractSectionRow
                    key={index}
                    contractLink={contractLink}
                    intervention={intervention}
                    codbban={codbban}
                    openingDate={openingDate}
                />
            );
        });

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    buildRowsWallets() {
        let data = this.filterData(this.props.immData, ['intervenerType']);
        let response = data.valueSeq().map((immData, index) => {
            const codbban = immData.get('fullContractNumber');
            const contractLink = `/myprofile/documentation/contracts/wallet/${immData.get('id')}`;
            const intervention = formatText(`interventionTypes-${immData.get('intervenerType')}`);
            const openingDate = null;

            return (
                <ContractSectionRow
                    key={index}
                    contractLink={contractLink}
                    intervention={intervention}
                    codbban={codbban}
                    openingDate={openingDate}
                />
            );
        });

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    buildContracts() {
        let content = <EmptyState primaryText={formatText('profileContracts-noData')} iconType="search-banking"/>;
        let rows = null;

        switch (this.props.type) {
            case 'accounts':
                rows = this.buildRowsAccounts();
                break;
            case 'credit-card':
                rows = this.buildRowsCards();
                break;
            case 'wallets':
                rows = this.buildRowsWallets();
                break;
            case 'loans':
                rows = this.buildRowsLoans();
                break;
            case 'mortgages':
                rows = this.buildRowsMortgages();
                break;
            case 'savings':
                rows = this.buildRowsDeposits();
                break;
            case 'credits':
                rows = this.buildRowsPreGrantedCredits();
                break;
        }

        content = (
            <div className="contract-section__list">
                <OKTable>
                    {rows}
                </OKTable>
            </div>
        );

        return content;
    }

    filterData(data, interventionType) {
        const { interventionSelected } = this.props;
        if (!interventionSelected) {
            return data;
        }

        return data.filter(
            (immData => {
                const currentInterventionType = immData.getIn(interventionType).trim();
                return (
                    currentInterventionType === interventionSelected || formatText(`interventionTypes-${currentInterventionType}`) === interventionSelected
                );
            }).bind(this)
        );
    }

    render() {
        const { title, type } = this.props;
        const groupIcon = 'rebrand-' + type;
        const iconClass = `contract-section__icon icon ${groupIcon}`;
        const rowsContracts = this.buildContracts();

        return (
            <section className="contract-section">
                <Accordion isExpanded={true} customClassName="contract-section__accordion">
                    <AccordionHeader name="AccordionHeader">
                        <div className="contract-section__accordion-header">
                            <i className={iconClass} />
                            <h3 className="contract-section__accordion-title">
                                {title}
                            </h3>
                        </div>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div className="contract-section__accordion-body">
                            {rowsContracts}
                        </div>
                    </AccordionBody>
                </Accordion>
            </section>
        );
    }
}

ContractSection.propTypes = {
    immContract: PropTypes.object,
    immContracts: PropTypes.object,
    immAccounts: PropTypes.object,
    immData: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    contracts: PropTypes.array,
    requestDocumentsPdf: PropTypes.func,
    type: PropTypes.string.isRequired,
    intervention: PropTypes.string,
    interventionSelected: PropTypes.string
};

ContractSection.defaultProps = {
    contracts: []
};

module.exports = ContractSection;
